import {client} from "@/data/axios";
import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";
import {ErrorReport} from "@/_helpers/memory";

export const uploadingError = (
    gallery: string,
    payload: string,
    filesize: number,
    filename: string,
    user: number,
    startTime: number,
    endTime: number,

    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/analytics/uploading/error`, {
        gallery, payload, filesize, filename, user, startTime, endTime
    })
        .then(() => {
            success();
        }).catch((error) => resolveError(error, failed));
};

export const uploading = (
    gallery: string,
    filesize: number,
    filename: string,
    user: number,
    startTime: number,
    endTime: number,

    data: any = {},

    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/analytics/uploading`, {
        gallery, filesize, filename, user, startTime, endTime, data: JSON.stringify(data),
    })
        .then(() => {
            success();
        }).catch((error) => resolveError(error, failed));
};

/**
 * Відправляє звіт про помилку на analytics endpoint
 */
export const reportError = (
    errorReport: ErrorReport,
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/analytics/uploading/error`, errorReport)
        .then(() => {
            success();
        }).catch((error) => {
            console.error('Failed to report error to analytics:', error);
            resolveError(error, failed);
        });
};

/**
 * Відправляє звіт про помилку пам'яті
 */
export const reportMemoryError = (
    message: string,
    context?: {
        galleryId?: number;
        fileName?: string;
        fileSize?: number;
    },
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const errorReport: ErrorReport = {
        type: 'memory_limit',
        message,
        memoryInfo: require('@/_helpers/memory').getMemoryInfo() || undefined,
        timestamp: Date.now(),
        userAgent: navigator.userAgent,
        memoryMonitoringEnabled: true, // Завжди true для помилок пам'яті
        ...context
    };

    reportError(errorReport, success, failed);
};

/**
 * Відправляє звіт про невідому помилку
 */
export const reportUnknownError = (
    error: any,
    context?: {
        galleryId?: number;
        fileName?: string;
        fileSize?: number;
        memoryMonitoringEnabled?: boolean;
    },
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const errorReport: ErrorReport = {
        type: 'unknown_error',
        message: error?.message || 'Unknown error occurred',
        details: {
            error: error?.toString(),
            stack: error?.stack,
            ...error
        },
        memoryInfo: require('@/_helpers/memory').getMemoryInfo() || undefined,
        timestamp: Date.now(),
        userAgent: navigator.userAgent,
        ...context
    };

    reportError(errorReport, success, failed);
};